import type {
  ContentBlockTag,
  StandardTag,
  Summary,
} from '../../types/smart-guide';
import type { Stage } from '../../types/Stage';
import { ContentBlockTags } from '../ContentBlockTags';
import { StandardTags } from '../StandardTags';

type Props = {
  summary: Summary;
  stage: Stage;
};

function NewStandardContent({ summary, stage }: Props): JSX.Element | null {
  const { newStandardContent } = summary;

  if (!newStandardContent || newStandardContent.length === 0) {
    return null;
  }

  if ('tooltipKey' in newStandardContent[0]) {
    const tags = newStandardContent as StandardTag[];

    return <StandardTags tags={tags} />;
  }

  const contentBlocks = newStandardContent as ContentBlockTag[];

  return (
    <ContentBlockTags
      stage={stage}
      tags={contentBlocks}
      hasAssessables={summary.assessables?.length > 0}
    />
  );
}

export { NewStandardContent };
